/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_Preset_Not_FoundInputs */



/**
* | output |
* | --- |
* | "Preset not found" |
*
* @param {Video_Export_Export_Preset_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_not_found = /** @type {((inputs?: Video_Export_Export_Preset_Not_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_Not_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prereglage introuvable")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voreinstellung nicht gefunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preimpostazione non trovata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительно заданные параметры не найдены")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preajuste no encontrado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट नहीं मिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Predefinição não encontrada")
	return /** @type {LocalizedString} */ ("Preset not found")
});